// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-ac67c789] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-navigation-input-confirm[data-v-ac67c789] {
  flex: 1 0 100%;
  width: 100%;
}
.app-navigation-input-confirm form[data-v-ac67c789] {
  display: flex;
}
.app-navigation-input-confirm__input[data-v-ac67c789] {
  height: 34px;
  flex: 1 1 100%;
  font-size: 100% !important;
  margin: 5px !important;
  margin-left: -8px !important;
  padding: 7px !important;
}
.app-navigation-input-confirm__input[data-v-ac67c789]:active, .app-navigation-input-confirm__input[data-v-ac67c789]:focus, .app-navigation-input-confirm__input[data-v-ac67c789]:hover {
  outline: none;
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  border-color: var(--color-primary-element);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcInputConfirmCancel-BanazdhC.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,6BAA6B;EAC7B,0CAA0C;AAC5C","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-ac67c789] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-navigation-input-confirm[data-v-ac67c789] {\n  flex: 1 0 100%;\n  width: 100%;\n}\n.app-navigation-input-confirm form[data-v-ac67c789] {\n  display: flex;\n}\n.app-navigation-input-confirm__input[data-v-ac67c789] {\n  height: 34px;\n  flex: 1 1 100%;\n  font-size: 100% !important;\n  margin: 5px !important;\n  margin-left: -8px !important;\n  padding: 7px !important;\n}\n.app-navigation-input-confirm__input[data-v-ac67c789]:active, .app-navigation-input-confirm__input[data-v-ac67c789]:focus, .app-navigation-input-confirm__input[data-v-ac67c789]:hover {\n  outline: none;\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  border-color: var(--color-primary-element);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
